import React from "react";
import {  useLocation } from "react-router-dom";
import DropdownMenu from "./DropdownMenu";
import DropdownMenuIfCards from "./DropdownMenuIfCards";

function Translations({ lang, translations, changeLanguage }) {
  const location = useLocation();

  const isIndexPage = location.pathname === "/";

  return (
    
    <div className="around">
      
      {/* <Link
        className={`${lang === "es" ? "blue-bold" : ""} lenguage-titles no-link`}
        to={`?lang=es`}
        onClick={() => changeLanguage("es")}
      >
        <p>ESP</p>
      </Link>
      <Link
        className={`${lang === "ca" ? "blue-bold" : ""} lenguage-titles no-link`}
        to={`?lang=ca`}
        onClick={() => changeLanguage("ca")}
      >
        <p>CAT</p>
      </Link>
      <Link
        className={`${lang === "en" ? "blue-bold" : ""} lenguage-titles no-link`}
        to={`?lang=en`}
        onClick={() => changeLanguage("en")}
      >
        <p>ENG</p>
      </Link> */}

      <div className="lenguage-titles">
        {/* Renderizar el menú basado en `isIndexPage` */}
        {isIndexPage ? (
          <DropdownMenu lang={lang} translations={translations} />
        ) : (
          <DropdownMenuIfCards lang={lang} translations={translations} />
        )}
      </div>
    </div>
  );
}

export default Translations;
